function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M21.9297 15.7692H17.9249L20.4298 0.280762H24.4344L21.9297 15.7692Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M36.4475 0.659404C35.6576 0.346017 34.4047 0 32.8555 0C28.9006 0 26.1156 2.10895 26.0985 5.12412C26.0657 7.3487 28.0925 8.58429 29.6084 9.32604C31.1578 10.084 31.6845 10.5787 31.6845 11.2543C31.6688 12.2919 30.4325 12.7702 29.2795 12.7702C27.6806 12.7702 26.8239 12.5236 25.5219 11.9464L24.9946 11.6989L24.4341 15.1757C25.3734 15.6036 27.104 15.9834 28.9006 16C33.1028 16 35.8385 13.9237 35.8709 10.7105C35.8869 8.94739 34.8166 7.59639 32.5093 6.49242C31.1086 5.78374 30.2507 5.30589 30.2507 4.58078C30.2672 3.9216 30.9763 3.24643 32.5574 3.24643C33.8594 3.21336 34.816 3.52631 35.5406 3.83948L35.9029 4.00394L36.4475 0.659404Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M41.7702 10.2822C42.1 9.3924 43.3691 5.94865 43.3691 5.94865C43.3525 5.98172 43.6983 5.04244 43.896 4.46582L44.1759 5.80039C44.1759 5.80039 44.9343 9.50781 45.099 10.2822C44.4731 10.2822 42.5612 10.2822 41.7702 10.2822ZM46.7137 0.280762H43.6159C42.6607 0.280762 41.9349 0.560641 41.5228 1.56584L35.5741 15.769H39.7762C39.7762 15.769 40.4681 13.8573 40.6168 13.4456C41.0778 13.4456 45.1656 13.4456 45.7586 13.4456C45.8736 13.9894 46.2365 15.769 46.2365 15.769H49.9446L46.7137 0.280762Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M14.5798 0.280762L10.6578 10.8424L10.2292 8.70036C9.50409 6.22875 7.23001 3.5434 4.69226 2.20816L8.28471 15.7528H12.5197L18.8146 0.280762H14.5798Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M7.01588 0.280762H0.57251L0.506592 0.59371C5.53282 1.87901 8.86159 4.97718 10.2292 8.70102L8.82852 1.58271C8.59792 0.593491 7.88924 0.313392 7.01588 0.280762Z",
  fill: "#FAA61A"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 49.438,
  height: 16,
  fill: "white",
  transform: "translate(0.506592)"
})));

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Visa.e101360d.svg";
export { ForwardRef as ReactComponent };